import moment from "moment";
import {
  BolDocument,
  BolFieldValue,
} from "../../../../app/data/pickup-requests/bolModels";
import { ApprovePickupReviewRequest } from "../../../../app/data/pickup-requests/models";

import { bolDateToApiFormat } from "./bolTimeUtils";

export const getBolFieldString = (field?: BolFieldValue | null): string | undefined => {
  if (field?.value == null) return undefined;
  const value = String(field.value).trim();
  return value || undefined;
};

export const normalizePickupDateForApprove = (value?: string): string | undefined => {
  const apiDate = bolDateToApiFormat(value);
  return apiDate || undefined;
};

export const normalizePickupTimeForApprove = (value?: string): string | undefined => {
  if (!value?.trim()) return undefined;

  const trimmed = value.trim();
  const formats = ["HH:mm:ss", "HH:mm", "h:mm a", "h:mm A", "h:mma", "h:mmA"];
  const parsed = moment(trimmed, formats, true);
  if (parsed.isValid()) return parsed.format("HH:mm");

  const loose = moment(trimmed, formats);
  return loose.isValid() ? loose.format("HH:mm") : trimmed;
};

export const extractPickupWindowForApprove = (doc?: BolDocument) => {
  const window = doc?.pickupWindow;

  return {
    pickupDate: normalizePickupDateForApprove(getBolFieldString(window?.windowDate)),
    pickupReadyTime: normalizePickupTimeForApprove(getBolFieldString(window?.windowStartTime)),
    pickupCloseTime: normalizePickupTimeForApprove(getBolFieldString(window?.windowEndTime)),
  };
};

export const buildApprovePickupReviewRequest = (
  correctedPayload: Record<string, unknown>,
  bolDocument: BolDocument | undefined,
  teamId?: string | null
): ApprovePickupReviewRequest => {
  const body: ApprovePickupReviewRequest = {
    correctedPayload,
    ...extractPickupWindowForApprove(bolDocument),
  };

  if (teamId) {
    body.teamId = teamId;
  }

  return body;
};
